import React from "react";
import { Form } from "antd";
export const getFormItems = (formSchema, values, getFieldDecorator) => {
  return formSchema.map(field =>
    getFormItem(field, values[field.field], getFieldDecorator)
  );
};
export const getFormItem = (field, value, getFieldDecorator) => {
  let formItemProps = {};
  if (field.formItemProps) {
    formItemProps = field.formItemProps;
  }
  if (!formItemProps.key) {
    formItemProps.key = field.field;
  }
  let decoratorOptions = {};
  if (field.decoratorOptions) {
    decoratorOptions = field.decoratorOptions;
  }
  if (value) {
    decoratorOptions.initialValue = value;
  }
  if (field.hidden) {
    formItemProps.style = { display: "none" };
  }
  // if (field.validationRules) {
  //   decoratorOptions.rules = field.validationRules;
  // }
  //formItemProps = {};
  return (
    <Form.Item {...formItemProps}>
      {getFieldDecorator(field.field, decoratorOptions)(field.formField)}
    </Form.Item>
  );
};

export const defaultFieldLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 }
  }
};

export const convertCustomFieldToFormParams = cf => {};
